export const FETCH_ALL = 'roles/FETCH_ALL';
export const FETCH_ALL_SUCCESS = 'roles/FETCH_ALL_SUCCESS';
export const FETCH_ALL_ERROR = 'roles/FETCH_ALL_ERROR';

export const FETCH_ALL_SPACE_MEMBERS = 'roles/FETCH_ALL_SPACE_MEMBERS';
export const FETCH_ALL_SPACE_MEMBERS_SUCCESS = 'roles/FETCH_SUCCESS_ALL_SPACE_MEMBERS';
export const FETCH_ALL_SPACE_MEMBERS_ERROR = 'roles/FETCH_ERROR_ALL_SPACE_MEMBERS';

export const CREATE = 'roles/CREATE';
export const CREATE_SUCCESS = 'roles/CREATE_SUCCESS';
export const CREATE_ERROR = 'roles/CREATE_ERROR';

export const UPDATE = 'roles/UPDATE';
export const UPDATE_SUCCESS = 'roles/UPDATE_SUCCESS';
export const UPDATE_ERROR = 'roles/UPDATE_ERROR';

export const DELETE = 'roles/DELETE';
export const DELETE_SUCCESS = 'roles/DELETE_SUCCESS';
export const DELETE_ERROR = 'roles/DELETE_ERROR';

export const SET_ACTIVE_ROLE_ID = 'roles/SET_ACTIVE_ROLE_ID';
